import { IMedicinePrescription as IMedicinePrescriptionItem, IPrescription, ISymptom } from "@curefit/care-common";
import { IPatientAllergy, IPatientRedFlag } from "@curefit/ehr-common";
import * as $ from "jquery";
import { mergeWith as _mergeWith, isNull as _isNull, isEmpty as _isEmpty, get as _get } from "lodash"
import * as React from "react";
import { isEqual as _isEqual } from "lodash";
import { connect } from "react-redux";
import { EHRTreatmentPlanRequestMapper } from "../../api/EhrTreatmentPlanRequestMapper";
import GenericEditViewCont from "../../containers/EditView/GenericEditViewCont";
import ErrorContainer from "../../containers/ErrorContainer";
import IAppointmentSchedule from "../../models/IAppointmentSchedule";
import IDoctorProfile from "../../models/IDoctorProfile";
import IEditedBy from "../../models/IEditedBy";
import { IFeatureConfig } from "../../models/IFeatureConfig";
import IPatientCondition from "../../models/IPatientCondition";
import { IPatientVitalResponse } from "../../models/IPatientVitalResponse";
import ITreatmentPlanTemplateResponseObj, { ITreatmentPlanTemplateSaveObj, ISuggestionType } from "../../models/ITreatmentPlanTemplateResponse";
import { IEHRSavePatientMedicalProfile, INewConfigData, ICommonPrescription } from "../../models/patients/IEHRSavePatientMedicalProfile";
import IMedicineType from "../../models/staticData/IMedicineType";
import { HOME_PAGE_ROUTE, RouteUtils } from "../../routes";
import { AdditionalSectionsToSaveInDraft, AppMessages, ConfigConstants, ConsultationStatusConstant, ModalSize, testWidgets, toastNotificationAppearance, PrescriptionTabModes, SEQUENTIAL_RECOMMENDATIONS_SECTIONS, AppConstants, BODY_PARTS_WIDGET, SUB_SECTIONS_CONTEXT_KEY } from "../../utils/AppConstants";
import AppUtils, { EpochConstants } from "../../utils/AppUtils";
import AutoSaveUtils from "../../utils/AutoSaveUtils";
import removeQ from "../../utils/DataUtils";
import { EventNames, SectionContext, FlowContext } from "../../utils/EventTrackerConstants";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import { Tracker } from "../../utils/Tracker";
import { EditViewDisplayMode } from "../common/EditViewCard";
import { ModalComponent } from "../ModalComponent";
import PatientVitalsSummaryBar from "../patient/summary-bar/PatientVitalsSummaryBar";
import ViewAllTemplatesModal from "../ViewAllTemplatesModal";
import ConfirmationModal from "../../containers/Patient/ConfirmationModal";
import TextInput from "../TextInput"
import { EHRRequestMapper } from "../../api/EHRRequestMapper";
import { OngoingConsultationActions } from "../../actions/OngoingConsultationActions";
import { CircuitBreakerUtils } from "../../utils/CircuitBreakerUtil";
import { LoaderProvider } from "../../context/loadingContext";
import { EditPrescriptionActions } from "../../actions/EditPrescriptionActions";
import { AlbusUrlConfigs } from "../../api/AlbusUrlConfigs";
import IDoctorSpeciality from "../../models/IDoctorSpeciality";
import { IAppState } from "../../models/IAppState";
import { IPastPrescription } from "../../models/prescription/IPastPrescription";

export const ViewModalComponents: any = {
    "TreatmentPlansModal": ViewAllTemplatesModal
}

type PrescriptionWidgetsKey = "reasonForVisit" | "chiefComplaints" | "prescriptionDiagnosis" | "prescriptionTemplateMapping" | "prescriptionLabTest" | "prescriptionMedicines" | "prescriptionAdvice" | "prescriptionFollowUp" | "prescriptionReferral"

interface CommonPatientPrescriptionTabDispatchProps {
    storeAppliedTemplateId: (templateId: string, flowContext: string) => void;
    getDoctorWiseSubSectionRecommendations?: (recommendation: any, doctorId: number, prescriptionDetails?: INewConfigData) => Promise<any>;
    storeDoctorOngoingPrescriptionRecommendations: (recommendations: any, key: string) => void;
    storeDoctorEditPrescriptionRecommendations: (recommendations: any, key: string) => void;
}

export interface CommonPatientPrescriptionTabProps {
    editedBy?: IEditedBy,
    patientId: number,
    consultationId: number,
    consultationType: string,
    patientVitals: IPatientVitalResponse[],
    patientAllergies: IPatientAllergy[],
    patientChiefComplaints: ISymptom[],
    patientRedFlags: IPatientRedFlag[],
    patientHistory: IPatientCondition[],
    prescriptionMedicationList: IMedicinePrescriptionItem[],
    prescription: IPrescription,
    saveEditedPrescription: (updatedPrescription: IPrescription) => void,
    reviewPrescription: (flag: boolean, clearPdfData: boolean) => void,
    staticSpecialities: IDoctorSpeciality[],
    staticMedicineTypes: IMedicineType[],
    fetchStaticDiseaseData: (input: string) => Promise<any>,
    fetchStaticLabTestsData: (input: string) => Promise<any>,
    fetchStaticLifeStyleData: (input: string) => Promise<any>,
    doctorType: string,
    updatePhysiotherapyPlanPdf: (file: File) => any,
    uploadPdf: () => void;
    currentMedicalProfile: IEHRSavePatientMedicalProfile,
    doctorProfile: IDoctorProfile,
    uiConfiguration: any[],
    nextTab: () => void,
    savePatientMedicalProfile: (patientId: number, patientMedicalProfile: any, appointmentId: number, doctorType: string) => Promise<any>,
    saveEditedMedicalProfile: (patientMedicalProfile: IEHRSavePatientMedicalProfile) => void,
    activeMedicines: any[],
    updateAppointmentStatus: (bookingId: number, appointmentId: number, status: ConsultationStatusConstant) => Promise<any>,
    bookingId: number,
    suggestions: { [key: string]: any },
    curefitUserId: string,
    metricIds: number[],
    fetchPatientVitals: (patientId: number, userId: number, metricIds: number[]) => any,
    updateCurrentConsultationData: (medicalProfile: IEHRSavePatientMedicalProfile) => void
    fetchDataOnSelect: (diagnosis?: Array<string>) => void
    featureConfigInfo: IFeatureConfig
    appointmentSchedule: IAppointmentSchedule
    prescriptionMode: PrescriptionTabModes
    navigateToDetails?: () => void
    excludeWidgets?: Array<PrescriptionWidgetsKey>
    currentTemplate?: ITreatmentPlanTemplateSaveObj
    saveTemplate?: (currentTemplate: ITreatmentPlanTemplateSaveObj) => void
    editMode: boolean
    updateCurrentTreatmentPlanData?: (currentTemplate: ITreatmentPlanTemplateSaveObj) => void
    onCancel?: () => void
    setDoctorRecommendedSuggestions?: (recommendations: ISuggestionType) => void;
    pastPrescriptions?: IPastPrescription[];
    isRecoSaveMode: boolean;
    productSpecs?: any;
}

const CommonPatientPrescriptionTab: React.FC<CommonPatientPrescriptionTabProps & CommonPatientPrescriptionTabDispatchProps> = (props) => {

    // Equivalent to class variables
    const isOngoingConsult = React.useRef<boolean>(props.prescriptionMode === PrescriptionTabModes.ONGOING);
    const isTreatmentPlan = React.useRef<boolean>(props.prescriptionMode === PrescriptionTabModes.TREATMENT_PLAN)
    const autoSaveTimer = React.useRef<any>();
    const isLHRAppt = _get(props.appointmentSchedule, "consultationSellableProduct.consultationProduct.productSpecs.allowedBodyParts", null);
    let widgetsToShow = AppUtils.getPrescriptionTabUIConfig(props.doctorType, props.uiConfiguration);
    if (isTreatmentPlan.current && !_isEmpty(props.excludeWidgets)) {
        widgetsToShow = (widgetsToShow as Array<PrescriptionWidgetsKey>).filter((widget: any) => {
            return (props.excludeWidgets.findIndex(e => e === widget.subSectionKey) < 0)
        })
    }
    if (isLHRAppt) {
        if (!widgetsToShow.find((widget: any) => widget.subSectionKey === SUB_SECTIONS_CONTEXT_KEY.BODY_PARTS)) {
            let bodyPartsWidget = BODY_PARTS_WIDGET;
            //set read only mode for edit mode
            if (props.prescriptionMode === PrescriptionTabModes.EDIT) {
                bodyPartsWidget.hideDeleteAndAddOption = true;
            }
            widgetsToShow.unshift(bodyPartsWidget);
            //find reasontovisit subsection index
            let index = widgetsToShow.findIndex((widget: any) => widget.subSectionKey === SUB_SECTIONS_CONTEXT_KEY.REASON_FOR_VISIT);
            widgetsToShow.splice(index, 1)
        }
    }
    const refs: { [key: string]: any } = widgetsToShow.reduce((object: any, widgetData: any) => {
        return (object[widgetData.subSectionKey] = React.useRef(), object)
    }, {});

    // States
    const [error, setError] = React.useState<{ msg: string, details: string }>({ msg: null, details: null });
    const [modal, setModal] = React.useState<boolean>(false);
    const [viewModal, setViewModal] = React.useState<boolean>(false);
    const [title, setTitle] = React.useState<string>("")
    const [isSaving, setIsSaving] = React.useState<boolean>(false);
    const [tabWidgets, setTabWidgets] = React.useState<any>(widgetsToShow);
    const [isLoadingSuggestions, setIsLoadingSuggestions] = React.useState(false);

    const section = React.useContext(SectionContext);
    const flowContext = React.useContext(FlowContext);

    React.useEffect(() => {
        // On Mount
        if (isOngoingConsult.current) {
            Tracker.time_event(EventNames.Prescription_Tab);
            if (autoSaveTimer.current !== undefined) clearInterval(autoSaveTimer.current);
            autoSaveTimer.current = setInterval(autoSavePrescription, 5 * EpochConstants.EPOCH_IN_A_SEC);
        } else if (isTreatmentPlan.current) {
            const templateName = _get(props, "currentTemplate.templateName", "")
            if (!_isEmpty(templateName)) {
                setTitle(templateName)
            }
        }
        document.getElementsByClassName("ongoing-consultation-main-cont")[0].scrollTop = 0;
        getSuggestionsSequentially(true);
        // Unmount
        return () => {
            if (isOngoingConsult.current) {
                console.log("CONSULTATION OVER")
                Tracker.track(EventNames.Prescription_Tab, { consultationId: props.consultationId });
                clearInterval(autoSaveTimer.current);
                saveEditedPrescription();
            }
        }
    }, [])

    const autoSavePrescription = () => {
        AutoSaveUtils.savePrescription(props.consultationId, getDraftSavingData());
        // $(".prescription-auto-save-icon").removeClass("hidden");
        // setTimeout(() => {
        //     $(".prescription-auto-save-icon").addClass("hidden")
        // }, 1000);
    }
    const segregateRefreceIdAndPlanId = (prescription: any) => {
        if (prescription.prescriptionTemplateMapping) {
            let templateIds: string[] = [];
            let referenceIds: string[] = prescription.prescriptionTemplateMapping.referenceIds || [];
            if (prescription.prescriptionTemplateMapping.templateIds && prescription.prescriptionTemplateMapping.templateIds.length) {
                prescription.prescriptionTemplateMapping.templateIds.forEach((id: string) => {
                    const idAsInteger: number = Number(id);
                    if (isNaN(idAsInteger)) {
                        templateIds.push(id);
                    } else {
                        referenceIds.push(id);
                    }
                });

                prescription.prescriptionTemplateMapping = { ...prescription.prescriptionTemplateMapping, referenceIds, templateIds };
            }

        }
        return prescription;
    }
    const composePrescription = () => {
        let prescription: any = {};
        tabWidgets.map((widgetData: any) => {
            // compose data only for the sections which are part of the prescription
            if (widgetData.dataToBeSaved && refs[widgetData.subSectionKey].current) {
                prescription[widgetData.subSectionKey] = refs[widgetData.subSectionKey].current.getSaveObject();
                getFormattedObject(widgetData, prescription);
            }
        })
        return segregateRefreceIdAndPlanId(prescription);
    }

    const onUndoApplyTreatmentPlan = (callback: Function, removedTemplate?: any) => {
        const prescription = composePrescription();
        props.updateCurrentConsultationData(prescription);
        callback();
        addTrackerMixpanel("templateIds", removedTemplate.templateId, removedTemplate.templateName, EventNames.Template_Plan_Remove, true);
    }

    const getFormattedObject = (widgetData: any, prescription: INewConfigData) => {
        let prescriptionData: any = (prescription as any)[widgetData.subSectionKey];
        delete prescriptionData.diagnosticData;
        delete prescriptionData.activeMedicines;
        let prescriptionKey = Object.values(prescriptionData);
        prescriptionKey.forEach((res: any) => {
            if (Array.isArray(res)) removeQ(res);
        })
    }

    const saveEditedPrescription = (composedPrescription?: any) => {
        let updatedPrescriptionObject: IPrescription = composedPrescription || composePrescription();
        props.saveEditedPrescription(updatedPrescriptionObject);
        let patientMedicalProfile: any = { ...props.currentMedicalProfile };
        tabWidgets.map((widgetData: any) => {
            if (patientMedicalProfile[ConfigConstants.NEWCONFIGDATA] && refs[widgetData.subSectionKey].current)
                patientMedicalProfile[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] = refs[widgetData.subSectionKey].current.getSaveObject();
        })
        props.saveEditedMedicalProfile(patientMedicalProfile);
    }

    const savePrescription = () => {
        clearInterval(autoSaveTimer.current);
        const composedPrescription = composePrescription();
        if (isOngoingConsult.current) {
            saveEditedPrescription(composedPrescription);
        }
        const draftData = getDraftSavingData(composedPrescription)
        AutoSaveUtils.savePrescription(props.consultationId, draftData);
        let patientMedicalProfile = { currentConsultationData: composedPrescription };
        let errorMessage = "";
        if (true) {
            setIsSaving(true);
            setError({ msg: null, details: null });
            props.savePatientMedicalProfile(props.patientId, patientMedicalProfile, props.consultationId, props.doctorType).then(() => {
                if (validatePrescription() && !errorMessage) {
                    props.reviewPrescription(true, true);
                }
            }).catch(err => {
                let schemaErrors: string[] = []
                if (Array.isArray(err)) {
                    err.map((element: any) => {
                        errorMessage += `${element.subSectionName}, `;
                        schemaErrors = [...schemaErrors, ...(element.errors || [])]
                    });
                    errorMessage = errorMessage.slice(0, -2);
                }
                setIsSaving(false);
                setError({
                    msg: AppMessages.PRESCRIPTION_VALIDATION_ERROR,
                    details: `Error in ${errorMessage} Please Review the form and proceed.\\n${schemaErrors.join("\\n")}`
                });
            });
        }
    }

    const clearErrorMessage = () => {
        setError({ msg: null, details: null });
    }

    const validatePrescription = (): boolean => {
        let status = true;
        let patientPrescription: any = {};
        tabWidgets.map((widgetData: any) => {
            if (refs[widgetData.subSectionKey].current) {
                patientPrescription[widgetData.subSectionKey] = refs[widgetData.subSectionKey].current.isFormDirty();
            }
        })
        let isDirty = Object.values(patientPrescription).findIndex(obj => obj === true) > -1;
        if (isDirty) {
            tabWidgets.map((widgetData: any) => {
                if (patientPrescription[widgetData.subSectionKey]) {
                    invalidItemError(widgetData.subSectionTitle);
                }
            })
            status = false;
        }
        return status;
    }

    const invalidItemError = (section: string) => {
        setError({
            msg: AppMessages.PRESCRIPTION_VALIDATION_ERROR,
            details: `Error in ${section}. Please Review the form and proceed.`
        });
    }

    const invalidSaveError = (section: string, errorText?: string, errorDetail?: string) => {
        let error = errorDetail || `Error in ${section}. Please Review the form and proceed.`;
        setError({
            msg: errorText || AppMessages.PRESCRIPTION_VALIDATION_ERROR,
            details: error
        });
    }

    const getDraftSavingData = (composedPrescriptionData?: any) => {
        let data = composedPrescriptionData || { ...composePrescription() }
        AdditionalSectionsToSaveInDraft.forEach((section: string) => {
            const sectionConfig = props.uiConfiguration.filter((widget) => widget.sectionKey === section)
            const subSectionKeys = (sectionConfig || []).map((subSection: any) => subSection.subSectionKey)
            if (!_isEmpty(subSectionKeys)) {
                subSectionKeys.map((key: string) => {
                    const currData = (props.currentMedicalProfile as any)[ConfigConstants.CURRENTCONSULTATION][key];
                    if (!_isEmpty(currData)) {
                        data[key] = currData
                    }
                })
            }
        })
        return data
    }

    const savePrescriptionInDraft = () => {
        clearTimeout(autoSaveTimer.current);
        AutoSaveUtils.savePrescription(props.consultationId, getDraftSavingData());
        props.updateAppointmentStatus(props.bookingId, props.consultationId, ConsultationStatusConstant.PRESCRIPTION_IN_DRAFT).then((response: any) => {
            if (!response.data.errorObject) {
                RouteUtils.navigateToHrefUrl("", HOME_PAGE_ROUTE);
            }
        }).catch((errorObject: any) => {
            invalidSaveError(null, errorObject.data.message, errorObject.message);
        })
    }

    const getPrescriptionEmptyStatuses = (): { isTitleEmpty: boolean, isPrescriptionEmpty: boolean, isDiagnosisEmpty: boolean, isBodyPartsCateredEmpty: boolean } => {
        const isTitleEmpty = _isEmpty(title)
        let isPrescriptionEmpty = true;
        let isDiagnosisEmpty = false;
        let isBodyPartsCateredEmpty = false;
        tabWidgets.forEach((widgetData: any) => {
            if (refs[widgetData.subSectionKey].current) {
                const subSectionEmptyStatus = refs[widgetData.subSectionKey].current.isDataEmpty();
                if (isTreatmentPlan.current && widgetData.subSectionKey === "prescriptionDiagnosis") {
                    isDiagnosisEmpty = Boolean(subSectionEmptyStatus)
                }
                else if (isLHRAppt && widgetData.subSectionKey === SUB_SECTIONS_CONTEXT_KEY.BODY_PARTS) { //[TODO] Adding validation because BodyPart wigdet is conditional. Need to move validation to backend. 
                    isBodyPartsCateredEmpty = Boolean(subSectionEmptyStatus);
                    isPrescriptionEmpty = false
                }
                else if (!subSectionEmptyStatus) {
                    isPrescriptionEmpty = subSectionEmptyStatus;
                }
            }
        })
        return {
            isTitleEmpty,
            isPrescriptionEmpty,
            isDiagnosisEmpty,
            isBodyPartsCateredEmpty
        };
    }

    const setErrorMessages = (emptyStatus: { isTitleEmpty: boolean, isDiagnosisEmpty: boolean, isPrescriptionEmpty: boolean, isBodyPartsCateredEmpty: boolean }) => {
        const { isTitleEmpty, isDiagnosisEmpty, isPrescriptionEmpty, isBodyPartsCateredEmpty } = emptyStatus

        // treatment plan errors
        if (isTreatmentPlan.current && (isTitleEmpty || isDiagnosisEmpty || isPrescriptionEmpty)) {
            // One missing
            if ((isTitleEmpty && !isDiagnosisEmpty && !isPrescriptionEmpty) ||
                (isDiagnosisEmpty && !isTitleEmpty && !isPrescriptionEmpty) ||
                (isPrescriptionEmpty && !isTitleEmpty && !isDiagnosisEmpty)) {
                setError({
                    msg: `Please enter ${isTitleEmpty ? "Title" : isDiagnosisEmpty ? "Diagnosis" : "at least one detail (Medicines, Advice, Lab Test, Referral, Follow Up)"} for the Treatment Plan`,
                    details: null
                })
            }

            // All Missing
            else if (isTitleEmpty && isDiagnosisEmpty && isPrescriptionEmpty) {
                setError({
                    msg: `Please fill the Title, Diagnosis and at least one detail (Medicines, Advice, Lab Test, Referral, Follow Up) for the Treatment Plan`,
                    details: null
                })
            }

            // Two Missing
            else if (isTitleEmpty && isDiagnosisEmpty) {
                setError({
                    msg: `Please fill the Title and Diagnosis for the Treatment Plan`,
                    details: null
                })
            }
            else if (isTitleEmpty && isPrescriptionEmpty) {
                setError({
                    msg: `Please fill the Title and at least one detail (Medicines, Advice, Lab Test, Referral, Follow Up) for the Treatment Plan`,
                    details: null
                })
            }
            else if (isDiagnosisEmpty && isPrescriptionEmpty) {
                setError({
                    msg: `Please fill the Diagnosis and at least one detail (Medicines, Advice, Lab Test, Referral, Follow Up) for the Treatment Plan`,
                    details: null
                })
            }
        }
        else if (isBodyPartsCateredEmpty) {
            setError({
                msg: `Please fill atleast one Body Part`,
                details: null
            })
        }
        else if (isPrescriptionEmpty) {  // ongoing or edit consultation errors
            setError({
                msg: `Prescription is Empty. Please fill at least one section item.`,
                details: null
            });
        }
    }

    const handleSave = (saveInDraft: boolean = false) => {
        isOngoingConsult.current && LocalStorageUtils.setClickEvents({
            field: saveInDraft ? EventNames.Complete_Later : EventNames.Complete_Now,
            section: EventNames.Complete_Prescription,
            widget: EventNames.Prescription
        });
        let hasEditModeItems = false, subSection = "";
        tabWidgets.map((widgetData: any) => {
            if (refs[widgetData.subSectionKey].current && refs[widgetData.subSectionKey].current.hasEditModeItem()) {
                hasEditModeItems = true;
                subSection = widgetData.subSectionTitle;
            }
        });
        const emptyStatus = getPrescriptionEmptyStatuses()
        const emptyCheck = (isTreatmentPlan.current && (emptyStatus.isPrescriptionEmpty || emptyStatus.isTitleEmpty || emptyStatus.isDiagnosisEmpty)) || (isLHRAppt && emptyStatus.isBodyPartsCateredEmpty) || (emptyStatus.isPrescriptionEmpty)
        if (hasEditModeItems) {
            setError({
                msg: `One or more items are not saved in ${subSection} section. Please save before proceeding`,
                details: null
            });
        } else if (saveInDraft) {
            savePrescriptionInDraft();
        } else if (emptyCheck) {
            setErrorMessages(emptyStatus)
        } else {
            switch (props.prescriptionMode) {
                case PrescriptionTabModes.ONGOING: {
                    savePrescription();
                    break;
                }
                case PrescriptionTabModes.EDIT: {
                    if (validatePrescription()) {
                        props.updateCurrentConsultationData(composePrescription())
                        props.reviewPrescription(true, true);
                    }
                    break;
                }
                case PrescriptionTabModes.TREATMENT_PLAN: {
                    setTitle(title.trim())
                    const dataToSave = EHRRequestMapper.getTemplateDataObjectToSave({ currentConsultationData: composePrescription() }, title)
                    props.saveTemplate(dataToSave)
                    break;
                }
                default:
            }
        }
    }

    const handleModalConfirm = () => {
        if (isTreatmentPlan.current) {
            props.onCancel()
        } else {
            props.navigateToDetails()
        }
    }

    const handleModalCancel = () => {
    }

    const fetchVitals = () => {
        props.fetchPatientVitals(props.patientId, parseInt(props.curefitUserId), props.metricIds);
    }

    const addTrackerMixpanel = (widget: string, value: string, templateName: string, updatingMethod: string, clickEvent: boolean = false) => {
        const trackerObject = {
            widget: widget,
            consultationId: props.consultationId,
            section: section,
            value: value,
            templateName: templateName,
            updatingMethod: updatingMethod
        };
        if (clickEvent) {
            LocalStorageUtils.setClickEvents(trackerObject);
        }
        else {
            Tracker.track(EventNames.Field_Added, trackerObject);
        }
    }
    const trackDuplicates = (value: any, widgetkey: string) => {
        Tracker.track(EventNames.Duplicate_Field_Detected, {
            flow: flowContext,
            section: section,
            widget: widgetkey,
            value: value,
            updatingMethod: EventNames.Treatment_Plan,
            consultationId: props.appointmentSchedule.id,
            doctorId: props.appointmentSchedule.doctor.id,
            specialityCode: props.appointmentSchedule.doctorType
        })
    }

    const findDuplicateEntries = (template: any, prescription: any) => {
        widgetsToShow.map((widget: any) => {
            const widgetConfiguration = widget.data[0]
            if (widgetConfiguration.uniqueKey) {
                const templateList = (template[widget.subSectionKey] ? template[widget.subSectionKey][widgetConfiguration.key] : []) || [];
                const prescriptionList = prescription[widget.subSectionKey][widgetConfiguration.key] || [];
                templateList.map((templateItem: any) => {
                    const templateItemValue = widgetConfiguration.trackerKey ? widgetConfiguration.trackerKey.split(".").reduce((a: any, v: any) => a[v], templateItem) : templateItem
                    const uniqueKey = widgetConfiguration.uniqueKey
                    const templateItemKey = uniqueKey.split(".").reduce((a: any, v: any) => a[v], templateItem)
                    prescriptionList.map((prescriptionItem: any) => {
                        const prescriptionItemKey = uniqueKey.split(".").reduce((a: any, v: any) => a[v], prescriptionItem)
                        if (_isEqual(templateItemKey, prescriptionItemKey)) {
                            trackDuplicates(templateItemValue, widgetConfiguration.key)
                        }
                    })
                })
            }
        })
    }

    const onTreatmentPlanSelect = (treatmentPlan: ITreatmentPlanTemplateResponseObj, fromModal: boolean = false) => {
        const { template } = treatmentPlan
        if (isTreatmentPlan.current) {
            LocalStorageUtils.setClickEvents({ field: EventNames.Select, section: section, templateName: treatmentPlan.templateName, widget: EventNames.Recommended_Treatment_Plans })
            let composedTemplateObj = EHRRequestMapper.getTemplateDataObjectToSave({ currentConsultationData: composePrescription() }, title)
            // findDuplicateEntries(template, composedTemplateObj.template);
            const combinedPrescription = { ...composedTemplateObj, template: _mergeWith(composedTemplateObj.template, template, AppUtils.mergeCustomizer) }
            props.updateCurrentTreatmentPlanData(combinedPrescription)
        } else {
            addTrackerMixpanel("templateIds", treatmentPlan.id, treatmentPlan.templateName, EventNames.Tags, true)
            const composedPrescription = composePrescription()
            const convertedTemplate = EHRRequestMapper.getEHRPrescriptionFromTreatmentPlanTemplate(template, treatmentPlan.templateName, treatmentPlan.id, props.staticSpecialities, addTrackerMixpanel)
            findDuplicateEntries(convertedTemplate, composedPrescription);
            const combinedPrescription = _mergeWith(composedPrescription, convertedTemplate, AppUtils.mergeCustomizer)
            props.updateCurrentConsultationData(combinedPrescription)
        }
        if ([EventNames.Edit_Prescription, EventNames.Consultation].includes(flowContext)) {
            props.storeAppliedTemplateId(treatmentPlan.id, flowContext);
        }
        if (treatmentPlan.isPastPrescription) {
            AppUtils.triggerToastNotification(`Successfully applied the Past Prescription dated: ${treatmentPlan.templateName}`, toastNotificationAppearance.success)
        } else {
            AppUtils.triggerToastNotification(`Successfully applied the Treatment Plan: ${treatmentPlan.templateName}`, toastNotificationAppearance.success)
        }
    }

    const getEmptyText = (widgetData: any): string => {
        if (widgetData.widgetEmptyTextConfiguration) {
            const widgetObj = refs[widgetData.widgetEmptyTextConfiguration.subSectionKey].current;
            const selfWidgetObj = refs[widgetData.subSectionKey].current;
            if (AppUtils.isDefined(widgetObj)) {
                const widgetObjData = widgetObj.getSaveObject()
                if (Array.isArray(widgetObjData[widgetData.widgetEmptyTextConfiguration.fieldKey]) &&
                    (widgetObjData[widgetData.widgetEmptyTextConfiguration.fieldKey] as Array<any>).length > 0) {
                    if (AppUtils.isDefined(selfWidgetObj)) {
                        const selfWwidgetObjData = selfWidgetObj.getSaveObject()
                        if (Array.isArray(selfWwidgetObjData[widgetData.widgetEmptyTextConfiguration.selfFieldKey]) &&
                            (selfWwidgetObjData[widgetData.widgetEmptyTextConfiguration.selfFieldKey] as Array<any>).length > 0) {
                            return (widgetData.widgetEmptyTextConfiguration.isSelfEmptyText)
                        }
                        else {
                            return (widgetData.widgetEmptyTextConfiguration.isNotEmptyText)
                        }
                    }
                    else {
                        return (widgetData.widgetEmptyTextConfiguration.isNotEmptyText)
                    }
                }
                else {
                    return (widgetData.widgetEmptyTextConfiguration.isEmptyText)
                }
            }
            else {
                return (widgetData.widgetEmptyTextConfiguration.isEmptyText)
            }
        }
        return null
    }

    const toggleModal = (flag: boolean) => {
        LocalStorageUtils.setClickEvents({ field: EventNames.Cancel, section: section })
        setModal(flag)
    }

    const renderActionButtons = (): JSX.Element => {
        let actionButtons: JSX.Element = null
        switch (props.prescriptionMode) {
            case PrescriptionTabModes.ONGOING: {
                actionButtons =
                    <>
                        <input className="card-primary-action with-border" type="button" value={"Complete Later"}
                            onClick={() => handleSave(true)} />
                        <input className="card-primary-action" type="button" value="Complete Now"
                            onClick={() => handleSave(false)} />
                    </>
                break;
            }
            case PrescriptionTabModes.EDIT: {
                actionButtons =
                    <>
                        <input className={"card-primary-action with-border"} type={"button"} value={"Cancel"}
                            onClick={() => setModal(true)} />
                        <input className={"card-primary-action"} type={"button"} value={"Review Changes and Update"}
                            onClick={() => handleSave()} />
                    </>
                break;
            }
            case PrescriptionTabModes.TREATMENT_PLAN: {
                actionButtons =
                    <>
                        <input className={"card-primary-action with-border"} type={"button"} value={"Cancel"}
                            onClick={() => toggleModal(true)} />
                        <input className={"card-primary-action"} type={"button"} value={"Review and Save"}
                            onClick={() => handleSave()} />
                    </>
                break;
            }
            default: { }
        }
        return actionButtons;
    }

    const cleanAndSetTitle = (event: any) => {
        const cleanedString = (event.target.value as string).trimLeft()
        setTitle(cleanedString)
    }

    const getRenderParameters = (widget: any) => {
        let savePatientConcern: any,
            cancelActionHandler: any,
            actionButtonText: any,
            ViewModalComponent: any

        const emptyText: string = getEmptyText(widget)

        if (widget.ViewModalConfiguration) {
            cancelActionHandler = (() => { setViewModal(true) })
            ViewModalComponent = ViewModalComponents[widget.ViewModalConfiguration.modalComponent]
            actionButtonText = { action: widget.ViewModalConfiguration.title, primaryAction: "" }
        }

        const ehrData = isTreatmentPlan.current
            ? !_isEmpty(props.currentTemplate.template)
                ? (props.currentTemplate.template as any)[widget.subSectionKey]
                : {}
            : props.currentMedicalProfile

        const { tabData, widgetData } = EHRRequestMapper.getRenderedWidgetTabData(props.prescriptionMode, ehrData, widget, props.currentTemplate, props.staticSpecialities)

        return {
            widgetData,
            tabData,
            savePatientConcern,
            cancelActionHandler,
            actionButtonText,
            ViewModalComponent,
            emptyText
        }
    }

    const onTreatmentPlanSelectFromModal = (templateObj: ITreatmentPlanTemplateResponseObj) => {
        if (isTreatmentPlan.current) {
            const newUpdatedObject = {
                ...refs.prescriptionTemplateMapping.current.state.updatedObject,
                templateIds: (refs.prescriptionTemplateMapping.current.state.updatedObject.templateIds || []).concat([
                    templateObj.id
                ])
            }
            refs.prescriptionTemplateMapping.current.updateHandler(newUpdatedObject)
            onTreatmentPlanSelect(templateObj)
        } else {
            onTreatmentPlanSelect(templateObj, true)
        }
    }

    /**
     * @param isInitialLoad Set to true when page is loading at start so that circuit breaker should not be applied.
     */
    const getSuggestionsSequentially = (isInitialLoad?: boolean) => {
        let counter: number, subSectionCount: number;
        const currentPrescription: IEHRSavePatientMedicalProfile | INewConfigData = EHRRequestMapper.getEHRSavePrescriptionRequestFromConfigBasedPrescription({ currentConsultationData: composePrescription() });

        if (!isInitialLoad) {
            //this is needed to set loader on suggestions section while api is in progress
            setIsLoadingSuggestions(true);
            counter = 0;
            subSectionCount = Object.keys(SEQUENTIAL_RECOMMENDATIONS_SECTIONS).filter(recommendation => SEQUENTIAL_RECOMMENDATIONS_SECTIONS[recommendation].isSequentialNeeded).length;
        }

        for (const [subSectionKey, subSectionValue] of Object.entries(SEQUENTIAL_RECOMMENDATIONS_SECTIONS)) {
            //to get suggestions on first time load where circuit breaker is not needed
            if (isInitialLoad) {
                props.getDoctorWiseSubSectionRecommendations(subSectionValue, props.appointmentSchedule.doctor.id, currentPrescription.newConfigData).then(response => {
                    saveSuggestions(response, subSectionKey);
                })
            }
            else {
                if (subSectionValue.isSequentialNeeded) {
                    const getSuggestionsCall = props.getDoctorWiseSubSectionRecommendations(subSectionValue, props.appointmentSchedule.doctor.id, currentPrescription.newConfigData);
                    const rollbarLogInfo = { url: AlbusUrlConfigs.getDoctorWiseSubSectionRecommendations(subSectionValue.url) }
                    CircuitBreakerUtils.fetchDataSequentially(getSuggestionsCall, AppConstants.FETCH_CARE_RECOMMENDATIONS_TIMEOUT_IN_SECONDS, rollbarLogInfo)
                        .then(response => {
                            counter++;
                            if (response) {
                                saveSuggestions(response, subSectionKey);
                            }
                            if (counter === subSectionCount) {
                                setIsLoadingSuggestions(false)
                            }
                        })
                }
            }
        }
    }

    const saveSuggestions = (suggestions: any, subSectionKey: string) => {
        switch (props.prescriptionMode) {
            case PrescriptionTabModes.ONGOING: props.storeDoctorOngoingPrescriptionRecommendations(suggestions, subSectionKey);
                break;
            case PrescriptionTabModes.EDIT: props.storeDoctorEditPrescriptionRecommendations(suggestions, subSectionKey);
                break;
            case PrescriptionTabModes.TREATMENT_PLAN: props.setDoctorRecommendedSuggestions({ [subSectionKey]: suggestions });
                break;
            default: { }
        }
    }

    const isMobile = AppUtils.getIsMobile();
    return (
        <div className="prescription-tab-container">
            {/*<ScrollToContainer componentToScroll={"ongoing-consultation-main-cont"} scrollItems={this.generateScrollItems()}/>*/}
            {!_isNull(error.msg) &&
                <ErrorContainer
                    errorText={error.msg} errorDetails={error.details} errorCode={0}
                    closeError={clearErrorMessage}
                    reportError={false} rollbarPayload={{
                        message: error,
                        errorDetails: error,
                        request: composePrescription()
                    }}
                />
            }
            {Boolean(isOngoingConsult.current && !isMobile) && (
                <div className="patient-info-subsection vitals-summary-section">
                    <PatientVitalsSummaryBar
                        patientVitals={props.patientVitals}
                        patientAllergies={props.patientAllergies}
                        fetchVitals={fetchVitals}
                    />
                </div>
            )}
            {modal &&
                <ModalComponent modalSize={"small"} className="confirmation-modal-prescription-page">
                    <ConfirmationModal
                        title={"Cancel Changes?"}
                        message={isTreatmentPlan.current ? AppMessages.EDIT_PRESCRIPTION_CANCEL_DIALOG : AppMessages.EDIT_PRESCRIPTION_CANCEL_DIALOG}
                        primaryActionText={"Cancel Changes"}
                        secondaryActionText={isTreatmentPlan.current ? "Return to Template" : "Return to Prescription"}
                        onConfirm={handleModalConfirm}
                        onCancel={handleModalCancel}
                        toggleModal={setModal}
                        shouldShowAttentionIcon={true}
                    />
                </ModalComponent>
            }
            {isTreatmentPlan.current &&
                <div key={"templateName"} className={"patient-info-subsection concern-section"}>
                    <div className={"treatment-plan-name-section"}>
                        <div className="col-xs-12 col-md-6">
                            <TextInput
                                widgetName={"TreatmentPlanTemplateTitle"}
                                name={"TreatmentPlanTemplateTitle"}
                                label={"Treatment Plan Name"}
                                getClassName={"text-input treatment-text-input"}
                                maxLength={50}
                                disabled={props.editMode && !props.isRecoSaveMode}
                                value={title}
                                onChange={cleanAndSetTitle}
                            />
                        </div>
                    </div>
                </div>
            }
            {
                widgetsToShow.map((widget: any) => {
                    const {
                        widgetData,
                        tabData,
                        savePatientConcern,
                        cancelActionHandler,
                        actionButtonText,
                        ViewModalComponent,
                        emptyText
                    } = getRenderParameters(widget);


                    const isRendered: boolean = AppUtils.shouldWidgetRender(widgetData, props.featureConfigInfo)

                    return isRendered
                        ? (
                            <LoaderProvider value={isLoadingSuggestions}>
                                <div key={widgetData.subSectionKey}
                                    className={"patient-info-subsection concern-section"}>
                                    <GenericEditViewCont
                                        ref={refs[widgetData.subSectionKey]}
                                        displayMode={EditViewDisplayMode.EDIT}
                                        appointmentId={props.consultationId}
                                        editedBy={null}
                                        patientId={props.patientId}
                                        widgetData={widgetData}
                                        tabData={tabData}
                                        doctorName={null}
                                        fetchPatientPastSessions={(patientId: number, subSectionKey: string) => Promise.reject()}
                                        subSectionTitle={null}
                                        className={null}
                                        modalHeaders={null}
                                        addSymptomForReview={(name: string) => Promise.reject()}
                                        responseData={null}
                                        modalResponse={null}
                                        suggestions={props.suggestions}
                                        isNew={true}
                                        onUndoApplyTreatmentPlan={onUndoApplyTreatmentPlan}
                                        onTreatmentPlanSelect={onTreatmentPlanSelect}
                                        fetchDataOnSelect={props.fetchDataOnSelect}
                                        savePatientConcern={savePatientConcern}
                                        cancelActionHandler={cancelActionHandler}
                                        actionButtonText={actionButtonText}
                                        emptyText={emptyText}
                                        appointmentSchedule={props.appointmentSchedule}
                                        getSuggestionsSequentially={getSuggestionsSequentially}
                                        pastPrescriptions={props.pastPrescriptions}
                                    />
                                    {Boolean(viewModal && ViewModalComponent) &&
                                        <ModalComponent modalSize={ModalSize.XTRALARGE}>
                                            <ViewModalComponent
                                                onTreatmentPlanSelect={onTreatmentPlanSelectFromModal}
                                                toggleModal={setViewModal}
                                            />
                                        </ModalComponent>
                                    }
                                </div>
                            </LoaderProvider>
                        )
                        : null
                })
            }
            <div className={`save-button collapsible-card ${isMobile ? "stick" : ""}`}>
                {renderActionButtons()}
            </div>
        </div>
    )
}

const maspStateToProps = (state: IAppState) => {
    return {
        pastPrescriptions: state.ongoingConsultation.pastPrescriptions,
    }
}

const mapDispatchToProps = (dispatch: any): CommonPatientPrescriptionTabDispatchProps => {
    return {
        storeAppliedTemplateId: (templateId: string, flowContext: string) => {
            dispatch(OngoingConsultationActions.storeAppliedTemplatesForCurrentConsultation(templateId, flowContext));
        },
        getDoctorWiseSubSectionRecommendations: (recommendation: any, doctorId: number, prescriptionDetails?: INewConfigData) => OngoingConsultationActions.getDoctorWiseSubSectionRecommendations(recommendation, doctorId, prescriptionDetails),
        storeDoctorOngoingPrescriptionRecommendations: (recommendations: any, key: string) => dispatch(OngoingConsultationActions.storeDoctorRecommendations(recommendations, key)),
        storeDoctorEditPrescriptionRecommendations: (recommendations: any, key: string) => dispatch(EditPrescriptionActions.storeDoctorRecommendations(recommendations, key))
    }
}

export default connect<void, CommonPatientPrescriptionTabDispatchProps, CommonPatientPrescriptionTabProps>(maspStateToProps, mapDispatchToProps)(CommonPatientPrescriptionTab);

2